export default __webpack_public_path__ + "static/yahoo-a5312e5135c2a12ae8c0159fe8bb8aea.png";